export const Marquee = () => {
  const text = "BE REMEMBERED — CRAFTED FOR ETERNITY — BONHEUR ETERNAL — ";
  return (
    <div className="relative overflow-hidden py-16 md:py-24 border-y border-white/[0.06] select-none" aria-hidden="true">
      <div className="marquee-track whitespace-nowrap">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="font-display text-6xl md:text-8xl lg:text-9xl tracking-tight text-transparent inline-block pr-8"
            style={{ WebkitTextStroke: "1px rgba(198,168,124,0.28)" }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};
